<div>
  @if (header.label && (!header.label.firstOnly || item.showLabel)) {
    <div
      [innerHTML]="getLabel(true)"
      [title]="getLabel() | striphtml"
      class="mat-title-large"
      id="catalog_header_txt_label"
    ></div>
  }

  @if (header.sublabel && (!header.sublabel.firstOnly || item.showSublabel) && !compact) {
    <div
      [innerHTML]="getSublabel(true)"
      [title]="getSublabel() | striphtml"
      class="mat-title-medium"
    ></div>
  }

  @if (header.additional && (!header.additional.firstOnly || item.showAdditional)) {
    <div
      [innerHTML]="header.additional.value"
      class="mat-title-small text-neutral-600"
    ></div>
  }
</div>
